<template>
  <div class="mb-1">
    <v-toolbar class="bg-navtop-calendar height-nav py-3" dense>
      <v-toolbar-title class="d-flex align-center">
        <i
          @click="backTo()"
          tag="i"
          class="v-icon notranslate icon-font-45-nav icon-text-red-d icon icon-LEFT theme--light icon-font-45 text-red-brown-two cursor-pointer"
        ></i>
        <span class="nav-font-24">{{ titlename }}</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-app-bar-nav-icon class="color-red-nav-icon nav-font-55 mx-2" @click="$emit('openmenu')" />
    </v-toolbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['titlename'])
  },

  methods: {
    backTo() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.icon-NOTE::before {
  color: #aa0c1e !important;
}
</style>
